module.exports = __webpack_public_path__ + "img/42_12.14fe416d.png";